import React, { useCallback, useContext } from 'react';
import getUTCNoonForDate from '../../../utils/getUTCNoonForDate';
import moment from '../../../utils/momentWithLocale';
import DateFieldView from '../view/DateFieldView';
import useTranslations from '../../../hooks/useTranslations';
import { FormContext, useField } from '../FormContext';

const DateFieldEngine = ({
  disablePast,
  disableFuture,
  internalId,
  value,
  setValue,
  required,
  readOnly,
  muiInputProps,
  ...fieldProps // for future development, know whe have this
}) => {
  const t = useTranslations();
  const { validateField, onFormBuilderDefaultValueSaved = () => {} } =
    useContext(FormContext);
  const onDateChange = date => {
    const chosenDate = date ? getUTCNoonForDate(date) : date;
    setValue(chosenDate);
    if (!date) {
      validateField(internalId, chosenDate);
    }
    onFormBuilderDefaultValueSaved(chosenDate);
  };

  const validator = useCallback(
    value => {
      value = value ? value : '';
      let error = '';

      const hasValue = typeof value === 'string' ? value.trim() !== '' : value;

      if (required && !hasValue) {
        error = t('forms.fields.error.required');
      }

      return error;
    },
    [required]
  );

  useField(internalId, validator);

  const viewProps = {
    disableFuture,
    disablePast,
    internalId,
    value: value ? moment.utc(new Date(value)) : value,
    onDateChange,
    dateFormat: moment.localeData().longDateFormat('L'),
    readOnly
  };

  return <DateFieldView {...viewProps} />;
};

export default DateFieldEngine;
